import { Radio } from '@typings';
import React from 'react';

import { RadioDot } from '../RadioDot/RadioDot';

export const RadioGroup = <T extends string>({
  describedById,
  isDisabled = false,
  isRequired,
  labelledById,
  name,
  options,
  value,
  onBlur,
  onChange,
}: Radio.Group<T>) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value as T);
  };

  return (
    <div role="radiogroup" aria-labelledby={labelledById} aria-describedby={describedById} className="flex flex-col gap-2">
      {options.map((option, index) => {
        const isChecked = option.value === value;
        const isOptionDisabled = isDisabled || option.isDisabled;

        return (
          <label
            key={`${option.value}-${index}`}
            className="flex cursor-pointer items-center gap-2 text-neutral-20 has-[:disabled]:cursor-not-allowed has-[:disabled]:text-neutral-90"
          >
            <RadioDot
              name={name}
              value={option.value}
              required={isRequired}
              checked={isChecked}
              disabled={isOptionDisabled}
              onBlur={onBlur}
              onChange={handleChange}
            />
            <span className="flex-1 body-2">{option.name}</span>
          </label>
        );
      })}
    </div>
  );
};
